import qs from "qs";
export default {
  data() {
    return {
      pickerOptions: {
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              let end = new Date();
              let start = new Date();
              start.setTime(start.getTime());
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "昨天",
            onClick(picker) {
              let end = new Date();
              let start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
              end.setTime(end.getTime() - 3600 * 1000 * 24 * 1);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "这周",
            onClick(picker) {
              let end = new Date();
              let start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * (7 - start.getDay()));
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "本月",
            onClick(picker) {
              let end = new Date();
              let start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * (start.getDate() - 1));
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "上个月",
            onClick(picker) {
              let end = new Date();
              let start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * (30 + start.getDate()));
              end.setTime(end.getTime() - 3600 * 1000 * 24 * end.getDate());
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一周",
            onClick(picker) {
              let end = new Date();
              let start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              let end = new Date();
              let start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      query: this.$route.query,
      descriptionsContentStyle: { "min-width": "1px", "max-width": "1px", "word-break": "break-all" },
      descriptionsLabelStyle: { width: "150px", "word-break": "break-all" },
    };
  },
  methods: {
    msgDialog(res) {
      if (!res) return;
      console.log("emit");
      Mirror.emit(`tips_dg_form_dialog_open`, res);
    },
    /**
     * @author 伟健 / 张
     * @name 修改分页
     */
    handlePageNoChange(index) {
      this.formData.pageNo = index;
      this.getList();
    },
    // 路由跳转
    push(param, type) {
      if (param && !type) {
        this.$router.push(param);
      }
      if (type == "open") {
        console.log(param.path);

        window.open(`${window.location.origin}${window.location.pathname}` + "/#" + param.path + "?" + qs.stringify(param.query));
      }
    },
    wopen(path, _self) {
      if (!path) return;
      if (_self) {
        window.location.href = path;
      } else {
        window.open(path);
      }
    },
    // 返回
    back(param) {
      if (param && !param.target) {
        this.$router.replace(param);
      } else {
        this.$router.back(); //返回上一层
      }
    },
  },
};
